document.addEventListener("DOMContentLoaded", function () {
  // All sliders
  window.SplideSliderFunction = function () {
    // Check if Splide is loaded
    if (typeof Splide === "undefined") {
      console.error("Splide library is not loaded.");
      return;
    }

    document.querySelectorAll(".splide").forEach((element) => {
      // Prevent duplicate initialization
      if (element.classList.contains("is-initialized")) {
        return;
      }

      const perPage = parseInt(element.dataset.perPage) || 1;
      const gap = element.dataset.gap || "24px";
      const drag = element.dataset.drag !== "false"; // default true
      const arrows = element.dataset.arrows === "true";
      const autoplay = element.dataset.autoplay === "true";
      const autoplayInterval =
        parseInt(element.dataset.autoplayintervel) || 3000;
      const type = element.dataset.type || "slide";
      const pagination = element.dataset.pagination === "true";

      /* Padding */
      const paddingLeft = element.dataset.paddingLeft
        ? element.dataset.paddingLeft + "px"
        : 0;

      const paddingRight = element.dataset.paddingRight
        ? element.dataset.paddingRight + "px"
        : 0;

      /* Breakpoints */
      let breakpoints = {};
      if (element.dataset.breakpoints) {
        try {
          breakpoints = JSON.parse(element.dataset.breakpoints);
        } catch (e) {
          console.warn(
            "Invalid breakpoints JSON:",
            element.dataset.breakpoints
          );
        }
      }

      /* Initialize Splide */
      const splide = new Splide(element, {
        type: type,
        perPage: perPage,
        gap: gap,
        drag: drag,
        arrows: arrows,
        pagination: pagination,
        autoplay: autoplay,
        interval: autoplayInterval,
        padding: {
          left: paddingLeft,
          right: paddingRight,
        },
        breakpoints: breakpoints,
      });

      /* Custom arrows */
      const prevBtn = element.querySelector(".splide-custom-prev");
      const nextBtn = element.querySelector(".splide-custom-next");

      if (prevBtn) {
        prevBtn.addEventListener("click", function (e) {
          e.preventDefault();
          splide.go("<");
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function (e) {
          e.preventDefault();
          splide.go(">");
        });
      }

      /* Arrow disable logic */
      const updateArrowState = function () {
        if (type === "loop") return;

        const index = splide.index;
        const end = splide.Components.Controller.getEnd();

        if (prevBtn) {
          prevBtn.classList.toggle("is-disabled", index === 0);
        }

        if (nextBtn) {
          nextBtn.classList.toggle("is-disabled", index >= end);
        }
      };

      /* Progress bar */
      const bar = element.querySelector(".my-carousel-progress-bar");

      splide.on("mounted move", function () {
        updateArrowState();

        if (bar) {
          const totalPages =
            splide.Components.Controller.getEnd() + 1;
          const currentPage = splide.index + 1;
          bar.style.width =
            (currentPage / totalPages) * 100 + "%";
        }
      });

      /* Mount slider */
      splide.mount();

      /* Mark as initialized */
      element.classList.add("is-initialized");
    });
  };

  // Run sliders
  window.SplideSliderFunction();
});




// document.querySelectorAll('.bg-img--ad').forEach(function (element) {
//   const img = element.querySelector('img');

//   if (img) {
//     const imgSrc = img.getAttribute('src');
//     element.style.background = `url("${imgSrc}")`;
//     img.style.display = 'none';
//     element.style.backgroundPosition = 'initial';
//   }
// });




